import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_SEARCH_PHARMACY_MEDICINES } from "../../action-types/actions";

import i18n from "../../i18n";
export const searchPharmacyMedicines = createAsyncThunk(
  ACTIONS_SEARCH_PHARMACY_MEDICINES.search_medicines,
  async ({ query = "", page = 1, limit = 20 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.searchPharmacyMedicines}?query=${query}&page=${page}&limit=${limit}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("toast.failedToSearchMedicines"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorSearchingMedicines");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
